import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logoap-emploi.png'


const _withScopeId = n => (_pushScopeId("data-v-1b458500"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "menu-logo",
  alt: "Logo",
  src: _imports_0
}, null, -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { slot: "side-bar" }
const _hoisted_7 = {
  slot: "footer",
  class: "footer"
}
const _hoisted_8 = { class: "app-links" }
const _hoisted_9 = { class: "app-footer" }
const _hoisted_10 = { class: "logged-user" }

import { useStoreAuth } from '@/store/auth'
import { computed } from 'vue'
import router, { goTo } from '@/router'
import { __ } from '@/locales'


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewMain',
  setup(__props) {

const storeAuth = useStoreAuth()
const version = '1.0.5'

const loggedUser = computed(() => storeAuth.user)
const mobile = computed(() => window.innerWidth < 600)

const logout = () => {
  storeAuth.logout()
  goTo({ name: 'Login' })
}

const goBack = () => {
  router.back()
}

return (_ctx: any,_cache: any) => {
  const _component_dig_ui_nav_bar_item = _resolveComponent("dig-ui-nav-bar-item")!
  const _component_dig_ui_side_bar_item = _resolveComponent("dig-ui-side-bar-item")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dig_ui_view = _resolveComponent("dig-ui-view")!

  return (_openBlock(), _createBlock(_component_dig_ui_view, {
    ref: "digUiView",
    "close-menu": "",
    class: "view"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_dig_ui_nav_bar_item, {
        slot: "nav-bar",
        class: "no-padding-on-desktop",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goTo)({ name: 'Home' })))
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_dig_ui_nav_bar_item, {
        slot: "nav-bar",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goTo)('/account')))
      }, {
        default: _withCtx(() => [
          (!_unref(mobile))
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('Nav.MyAccount')), 1))
            : _createCommentVNode("", true),
          (_unref(mobile))
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('Nav.MyAccountShort')), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_dig_ui_nav_bar_item, {
        slot: "nav-bar",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (logout()))
      }, {
        default: _withCtx(() => [
          (!_unref(mobile))
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('Nav.Logout')), 1))
            : _createCommentVNode("", true),
          (_unref(mobile))
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('Nav.LogoutShort')), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("nav", _hoisted_6, [
        _createVNode(_component_dig_ui_side_bar_item, {
          class: "side-bar-title",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (goBack()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('Nav.Previous')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_dig_ui_side_bar_item, {
          class: "side-bar-title",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(goTo)({ name: 'Home' })))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('Nav.Home')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_dig_ui_side_bar_item, {
          class: "side-bar-title",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(goTo)({ name: 'Customers' })))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('Nav.Customers')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_dig_ui_side_bar_item, {
          class: "side-bar-title",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(goTo)({ name: 'Worksites' })))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('Nav.Worksites')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_dig_ui_side_bar_item, {
          class: "side-bar-title",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(goTo)({ name: 'Tools' })))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('Nav.Tools')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_dig_ui_side_bar_item, {
          class: "side-bar-title",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(goTo)({ name: 'Messaging' })))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('Nav.Messaging')), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_router_view, { slot: "content" }),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Nav.Home')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/account" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Nav.MyAccount')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/customers" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Nav.Customers')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/worksites" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Nav.Worksites')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/tools" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Nav.Tools')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/messaging" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Nav.Messaging')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", { class: "version" }, "Cap Emploi " + _toDisplayString(version)),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(loggedUser)?.username) + " (" + _toDisplayString(_unref(loggedUser)?.role) + ") ", 1)
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})